import { dataClock } from 'dls-icons-data'
import { createIcon } from '../common'

const IconClock = /*#__PURE__*/createIcon(dataClock)
export default IconClock
